// eslint-disable-next-line import/prefer-default-export
export const domain =
  // eslint-disable-next-line no-nested-ternary
  import.meta.env.VITE_ENV === 'production'
    ? 'olino.fr'
    : import.meta.env.VITE_ENV === 'staging'
    ? 'olino-staging.fr'
    : undefined
